import type * as React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {UserContextProvider} from '@/components/Providers/UserContext';
import MyRentals from '@/pages/MyRentals';
import NotFound from '@/pages/NotFound';
import SignOut from '@/pages/SignOut';
import Home from '@/pages/Home';
import MyDigitalCodes from './pages/MyDigitalCodes';
import CourseApprovals from '@/pages/CourseApprovals';
import SupervisorAccess from "@/pages/SupervisorAccess";

const App = () : React.ReactElement => {
    return (
        <UserContextProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/">
                        <Route index element={<Home/>}/>
                    </Route>
                    <Route
                        path="/my-rentals"
                        element={<MyRentals/>}
                    />
                    <Route
                        path="/supervisor-access"
                        element={<SupervisorAccess/>}
                    />
                    <Route
                        path="/course-approvals"
                        element={<CourseApprovals/>}
                    />
                    <Route
                        path="/my-digital-codes"
                        element={<MyDigitalCodes/>}
                    />
                    <Route
                        path="/sign-out"
                        element={<SignOut/>}
                    />
                    <Route
                        path="*"
                        element={<NotFound/>}
                    />
                </Routes>
            </BrowserRouter>
        </UserContextProvider>
    );
};

export default App;
